
import { Component, Prop, Vue } from 'nuxt-property-decorator';

@Component({
  components: {},
})
export default class PagePagination extends Vue {
  currentCat: any = [];

  activeBreadcrumb: any = {};

  @Prop({
    type: Array,
    default() {
      return [];
    },
  })
  private readonly breadcrumbs!: any[];

  @Prop({
    type: Boolean,
    default: false,
  })
    isProduct!: boolean;

  get setBreadcrumbs() {
    const breadcrumbsList = this.breadcrumbs || [];
    const categories = this?.$store?.state?.catalog?.categories || [];

    breadcrumbsList.forEach((item) => {
      // устанавливаем последнюю крошку из текущих крошек
      const category = item.path.split(/[//]/gi).splice(-1).join('');
      // получаем ид родителя
      const parentId = categories.find((t: any) => t.slug == category)?.parentId || '';

      if (parentId) {
        const currentCats = categories.filter(
          // фильтруем нужные нам категории
          (cat: any) => cat.parentId == parentId && cat.name !== item.title,
        );
        item.categories = currentCats;
      }
    });

    return breadcrumbsList;
  }
}
